import Axios from "axios";
import { getPrefix, getSessionToken } from "../bandung";
import { objectToFormData } from "./helpers";

const getUserEmailPrefix = () => `${getPrefix()}/app/useremail`;

const getUserEmailDeleteEndPoint = () => `${getUserEmailPrefix()}/delete`;
const getUserEmailListEndPoint = () => `${getUserEmailPrefix()}/list`;
const getUserEmailListByUserEndPoint = () => `${getUserEmailPrefix()}/listbyuseralpha`;
const getUserEmailViewEndPoint = () => `${getUserEmailPrefix()}/view`;

const userEmailDelete = async (userEmailEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    userEmailEntityId: userEmailEntityId,
  });
  try {
    const response = await Axios.post(getUserEmailDeleteEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "User email deleted successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const userEmailList = async (
  page,
  listByAlpha = true,
) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    page: page,
  });
  const url = getUserEmailListEndPoint() + (listByAlpha ? "allalpha" : "");
  try {
    const response = await Axios.post(url, form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "User email list loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const userEmailListByUser = async (
  userEntityId,
) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    userEntityId: userEntityId,
  });
  try {
    const response = await Axios.post(getUserEmailListByUserEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "User email list loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

const userEmailView = async (userEmailEntityId) => {
  const form = objectToFormData({
    sessionToken: getSessionToken(),
    userEmailEntityId: userEmailEntityId,
  });
  try {
    const response = await Axios.post(getUserEmailViewEndPoint(), form);
    if (!response.data.error) {
      return {
        code: "SUCCESS",
        message: "User email loaded successfully",
        data: response.data,
      };
    } else {
      throw new Error(response.data.error);
    }
  } catch (error) {
    return {
      code: "ERROR",
      message: error.message || "An error occurred.",
    };
  }
};

export {
  userEmailDelete,
  userEmailList,
  userEmailListByUser,
  userEmailView,
};